export default function CallToAction() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative bg-[#080808] py-20 md:py-28 px-6 overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-96 h-96 bg-[#00FF88]/5 rounded-full blur-3xl"></div>
      </div>
      <div className="relative max-w-3xl mx-auto text-center">
        <p className="text-[#00FF88] text-sm font-bold uppercase tracking-widest mb-4">Último llamado</p>
        <h2 className="text-3xl md:text-5xl font-black text-white leading-tight mb-4">
          No dejes que otro mes se escape sin control
        </h2>
        <p className="text-gray-400 text-lg mb-10">
          Únete a los estrategas que ya dominan sus números financieros y su inventario.
        </p>
        <a
          href="https://pay.hotmart.com/H105250353B?checkoutMode=10"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-[#00FF88] to-[#00cc6a] text-black font-black text-lg md:text-xl px-10 py-6 rounded-2xl hover:scale-105 transition-all duration-300 cursor-pointer text-center w-full sm:w-auto max-w-sm sm:max-w-none mx-auto whitespace-nowrap"
        >
          <span className="leading-snug">
            ACCEDER AHORA<br className="block" />
            POR $12/AÑO →
          </span>
        </a>
        <p className="text-gray-600 text-xs mt-5">
          Acceso inmediato · Respaldado en la nube · Sin contratos ni sorpresas
        </p>
      </div>
    </section>
  );
}
